import { render, staticRenderFns } from "./RenewalManagement.vue?vue&type=template&id=3d0ed8e8&scoped=true&"
import script from "./RenewalManagement.vue?vue&type=script&lang=js&"
export * from "./RenewalManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0ed8e8",
  null
  
)

export default component.exports